/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceHistoryDataPoint
 */
export interface BalanceHistoryDataPoint {
    /**
     * Unix timestamp in seconds
     * @type {number}
     * @memberof BalanceHistoryDataPoint
     */
    timestamp: number;
    /**
     * Total portfolio balance in USD at this timestamp
     * @type {number}
     * @memberof BalanceHistoryDataPoint
     */
    balanceUsd: number;
}

/**
 * Check if a given object implements the BalanceHistoryDataPoint interface.
 */
export function instanceOfBalanceHistoryDataPoint(value: object): value is BalanceHistoryDataPoint {
    let isInstance = true;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "balanceUsd" in value && value["balanceUsd"] !== undefined;

    return isInstance;
}

export function BalanceHistoryDataPointFromJSON(json: any): BalanceHistoryDataPoint {
    return BalanceHistoryDataPointFromJSONTyped(json, false);
}

export function BalanceHistoryDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceHistoryDataPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'timestamp': json['timestamp'],
        'balanceUsd': json['balance_usd'],
    };
}

export function BalanceHistoryDataPointToJSON(value?: BalanceHistoryDataPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'timestamp': value.timestamp,
        'balance_usd': value.balanceUsd,
    };
}

